import React, { useMemo } from 'react';

import {
  APIOrderCustomFieldValue,
  APIOrderFieldsSchemaModel,
} from '@cd3p/core/types/api';
import { filterFieldsByCompanyId } from '@cd3p/core/utils/orderFieldsSchema';
import { ReadOnlyField } from 'components';
import { useTranslation } from 'react-i18next';

type OrderCustomFieldsViewProps = {
  orderFieldsSchema?: APIOrderFieldsSchemaModel;
  orderFieldValues?: APIOrderCustomFieldValue[];
  companyId?: string;
};

export const OrderCustomFieldsView: React.FC<OrderCustomFieldsViewProps> = ({
  orderFieldsSchema,
  orderFieldValues,
  companyId,
}) => {
  const { t } = useTranslation();

  const getFieldValue = (fieldName: string) => {
    return (
      orderFieldValues?.find(it => it.name === fieldName)?.value ||
      t('common.entityNameUndefined')
    );
  };

  const filteredFields = useMemo(
    () => filterFieldsByCompanyId(orderFieldsSchema?.fields, companyId),
    [orderFieldsSchema?.fields, companyId],
  );

  if (!filteredFields) {
    return null;
  }

  return (
    <>
      {filteredFields.map(field => {
        const fieldValue = getFieldValue(field.name);

        return (
          <ReadOnlyField
            key={field.name}
            label={field.label}
            value={fieldValue}
          />
        );
      })}
    </>
  );
};
